export default __webpack_public_path__ + "static/media/840.891c26b8.png";